import { combineReducers } from "redux";

import { walletDetails } from "./wallet.reducer"
const walletReducers = combineReducers({
    walletDetails
})
export default walletReducers;